import httpRequest from '@/utils/request';

const detailSheetUrl = '/Report/detailed';
const summarySheetUrl = '/Report/summary';

export const loadDetailSheetData = (
  params: IReport.IDetailSheet.IRequestDetailSheetParams,
): Promise<IReport.IDetailSheet.IResponseToDetailSheet> => {
  return httpRequest.get(detailSheetUrl, {
    params,
  });
};
export const loadSummarySheetData = (
  params: IReport.ISummarySheet.IRequestSummarySheetParams,
): Promise<IReport.ISummarySheet.IResponseToSummarySheet> => {
  return httpRequest.get(summarySheetUrl, {
    params,
  });
};

